<template>
  <div class="row invoice-info" v-if="!isZeenow">
    <div class="col-xs-12">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th>Payments</th>
              <th>Amount</th>
              <th>Due</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(payment, index) in getAscOrderedPaymentList"
              :key="index"
              class="payments-table-row"
            >
              <td>Payment #{{ index + 1 }}:</td>
              <td v-if="payment.status == 'confirmed' ">- {{ payment.amount | currency }}</td>
              <td
                v-else-if="payment.status == 'rejected'"
                style="text-decoration: line-through;color:#ccc"
              >{{ payment.amount | currency }}</td>
              <td v-else-if="payment.amount == 0" style="color:#ccc">Not paid yet.</td>
              <td v-else style="color:#ccc">{{ payment.amount | currency }}</td>
              <td>
                <span>{{ payment.due | moment('DD/MM/YYYY') }}</span>
                &nbsp;&nbsp;
                <el-button
                  v-if="checkUserGroup(getGroups.FACTORY) || checkUserGroup(getGroups.MANAGE)"
                  :plain="true"
                  type="text"
                  size="small"
                  @click="openEditDueDialog(payment.id, index)"
                >Edit</el-button>
              </td>
              <td>
                <el-tag class="table-tags" v-if="payment.status == 'pending'" type="warning">Pending</el-tag>
                <el-tag
                  class="table-tags"
                  v-else-if="payment.status == 'pending-confirmation'"
                  type="primary"
                >Pending confirmation</el-tag>
                <el-tag
                  class="table-tags"
                  v-else
                  :type="payment.status == 'confirmed' ? 'success' : 'danger'"
                >{{ payment.status == 'confirmed' ? 'Confirmed' : 'Rejected' }}</el-tag>
              </td>
            </tr>
            <tr>
              <th>Total left:</th>
              <th>{{ getTotalPaid | currency }}</th>
              <th></th>
              <th>
                <el-tag
                  class="table-tags paid"
                  v-if="getPurchaseOrder.payment.status == 'paid'"
                  type="success"
                >Paid</el-tag>
                <el-tag class="table-tags pending" v-else type="warning">Pending</el-tag>
              </th>
            </tr>
          </tbody>
        </table>
        <el-dialog :title="editDueTitle" :visible.sync="editDueDialog">
          <el-form :model="editDueForm" :rules="editDueRules" ref="editDueForm">
            <el-form-item label="New due date" :label-width="formLabelWidth" prop="due">
              <el-date-picker
                v-model="editDueForm.due"
                type="date"
                ref="due"
                format="dd/MM/yyyy"
                :disabled="isEditDueLoading"
                placeholder="Select a new due date"
              ></el-date-picker>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="editDueDialog = false">Cancel</el-button>
            <el-button
              type="success"
              :loading="isEditDueLoading"
              @click="submitNewDue('editDueForm')"
            >Confirm</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as groups from "@/js/user-groups";
import { getDateTimezoneUser } from "@/helpers/user-timezone";

export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      selectedPayment: null,
      editDueDialog: false,
      selectedPaymentIndex: null,
      isEditDueLoading: false,
      formLabelWidth: "120px",
      editDueForm: {
        due: ""
      },
      editDueRules: {
        due: [{ required: true, message: "Due is required" }]
      }
    };
  },
  computed: {
    ...mapGetters({
      getPayments: "getPayments",
      getHasPaymentDue: "getHasPaymentDue",
      getUser: "getUser",
      isZeenow: "isZeenow"
    }),
    getGroups() {
      return groups;
    },
    getPurchaseOrder() {
      return this.$store.getters.getPOItem;
    },
    getAscOrderedPaymentList() {
      function sortByAscId(a, b) {
        const id1 = a.id;
        const id2 = b.id;
        return id1 < id2 ? -1 : id1 > id2 ? 1 : 0; // eslint-disable-line
      }
      return this.getPurchaseOrder.payment.payments.slice().sort(sortByAscId);
    },
    getTotalPaid() {
      let paymentsTotal = 0;
      for (
        let i = 0;
        i < this.getPurchaseOrder.payment.payments.length;
        i += 1
      ) {
        if (this.getPurchaseOrder.payment.payments[i].status === "confirmed") {
          paymentsTotal += parseFloat(
            this.getPurchaseOrder.payment.payments[i].amount
          );
        }
      }
      if (this.item.amount - paymentsTotal < 0) {
        return 0;
      }
      return this.item.amount - paymentsTotal;
    },
    editDueTitle() {
      return `Edit due date for payment#${this.selectedPaymentIndex}`;
    }
  },
  methods: {
    dateTimezoneUser(date) {
      return getDateTimezoneUser(date);
    },
    checkUserGroup(group) {
      if (process.env.NODE_ENV === "production") {
        for (let i = 0; i < this.getUser.groups.length; i += 1) {
          if (
            this.getUser.groups[i].name.toLowerCase() === group.toLowerCase()
          ) {
            return true;
          }
        }
      }
      return true;
    },
    openEditDueDialog(id, index) {
      this.editDueDialog = true;
      this.selectedPayment = id;
      this.selectedPaymentIndex = index + 1;
    },
    submitNewDue(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const newDueDate = JSON.stringify(this.editDueForm.due);
          const cleanDue = newDueDate
            .substring(0, newDueDate.indexOf("T"))
            .replace('"', "");
          const paymentObj = {
            payment: {
              payments: [
                {
                  id: this.selectedPayment,
                  due: cleanDue
                }
              ]
            }
          };
          this.$store.dispatch("setPaymentDue", {
            poId: this.item.id,
            paymentDue: paymentObj,
            scope: this
          });
        }
        return false;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
th,
td {
  width: 33.33%;
}
.table > thead > tr > th {
  border: 0;
}
.el-tag.table-tags {
  width: 112px;
  text-align: center;
  &.pending {
    background: #f7ba2a;
    color: white;
  }
  &.paid {
    background: #13ce66;
    color: white;
  }
}
.table > tbody > tr > th,
.table > tbody > tr > td {
  vertical-align: middle;
  border-color: #f5f4f4;
  padding: 6px 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/purchase-orders/purchase-order/partials/payment-partials/PoPaymentsTable.vue